export default function(instance) {
  return {
    // options设置是否loading和 错误提示 tips 也可以直接设置 希望大家根据业务灵活运用
    getBrowerContent(params, options) {
      return instance.get(
        "content/info",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    getBrowerHall(params, options) {
      return instance.get(
        "hall/info",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    newComment(payload, options) {
      return instance.post("message/create", payload, options)
    },
    liuyanList(params, options) {
      return instance.get(
        "message/list",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    huifuList(params, options) {
      return instance.get(
        "reply/list",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    searchList(params, options) {
      return instance.get(
        "search/list",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    groupList(params, options) {
      return instance.get(
        "group/list",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    createMessage(payload, options) {
      return instance.post("message/create", payload, options)
    },
    praise(params, options) {
      return instance.get(
        "hall/praise",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    browse(params, options) {
      return instance.get(
        "hall/browse",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    getPanoramas() {
      return instance.get("all", {}, { isShowLoading: true, isShowTips: false })
    },
    getClassifyList() {
      return instance.get(
        "getTypes",
        {},
        {
          isShowLoading: true,
          isShowTips: false,
        }
      )
    },
    getClassifyTree(params) {
      return instance.get(
        "getTreeTypes",
        { params },
        {
          isShowLoading: true,
          isShowTips: false,
        }
      )
    },
    getPanoramasByClassify(params) {
      params.pageSize = 9999
      return instance.get(
        "getScenePage",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    getPanorama(params) {
      return instance.get(
        "info",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
    getGuideUrl() {
      return instance.get(
        "accreditation",
        {},
        { isShowLoading: true, isShowTips: false }
      )
    },
    getMapAndPoints() {
      return instance.get("map", {}, { isShowLoading: true, isShowTips: false })
    },
    getHotInfo(params, options) {
      return instance.get(
        "getHotInfo",
        { params },
        { isShowLoading: true, isShowTips: false }
      )
    },
  }
}
